// removed by extract-text-webpack-plugin
module.exports = {"people":"NetworkPersonPicker__people___3OIsO","word":"NetworkPersonPicker__word___AUTQ5","person":"NetworkPersonPicker__person___3cV14","name":"NetworkPersonPicker__name___3qjvz","chosen":"NetworkPersonPicker__chosen___1vQKV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/questions/NetworkPersonPicker.scss
// module id = 585
// module chunks = 1